import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import { EmtTypography, EmtModal, EmtSeparator } from 'emt-components-v2'
import { PetsitterAvatar } from '@/components/PetSitter/PetsittersSelection/PetsitterAvatar'
import { EmptyPetsitterSlot } from '@/components/PetSitter/PetsittersSelection/EmptyPetsitterSlot'
import { useIsResponsive } from '@/hooks'
import { getProfileAsync } from '@/modules/PetSitter/viewProfileServiceHelper'
import LinkButton from '@/components/EMT/LinkButton'
import { Routes } from '@/assets/configs'
import { useNewRequestCartStore } from '@/store/newRequestCartStore'

interface SelectMoreModalProps {
  open: boolean
  setOpen: (open: boolean) => void
  id: string
}

const SelectMoreModal: React.FC<SelectMoreModalProps> = ({ open, setOpen, id }) => {
  const [petsitters, setPetsitters] = useState<any[]>([])
  const petsittersIds = useNewRequestCartStore((s) => s.petsittersIds)
  const [isMobile] = useIsResponsive()

  useEffect(() => {
    const fetchPetsitters = async () => {
      if (petsittersIds.length === 0) {
        setPetsitters([])
        return
      }
      try {
        const results = await Promise.all(petsittersIds.map((id) => getProfileAsync(id)))
        setPetsitters(results)
      } catch (error) {
        console.error('Error fetching petsitters:', error)
      }
    }

    fetchPetsitters()
  }, [petsittersIds])
  return (
    <EmtModal
      open={open}
      onClose={() => setOpen(false)}
      sx={{
        '& .inner-box': {
          width: '605px',
          maxWidth: '90vw',
          backgroundColor: '#F9F9F9',
        },
        '& .children-box': { padding: '24px' },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            justifyContent: 'space-between',
            paddingRight: '30px',
          }}
        >
          <EmtTypography variant="h4" fontWeight={800}>
            Votre sélection
          </EmtTypography>
          <EmtTypography variant="body2" sx={{ fontWeight: 700, color: '#A5A3A9', lineHeight: '1.1', flexShrink: 0 }}>
            {petsittersIds.length} / 10
          </EmtTypography>
        </Box>
        <EmtSeparator />
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            flexWrap: isMobile ? 'nowrap' : 'wrap',
            padding: '0 2px',
            overflowX: isMobile ? 'scroll' : 'auto',
            maxWidth: '100%',
            paddingRight: isMobile ? '57px' : '0',
          }}
        >
          {petsitters?.map((petsitter) => (
            <PetsitterAvatar
              key={petsitter.uuid}
              uuid={petsitter.uuid}
              name={petsitter.name}
              mainPicture={petsitter.mainPicture}
            />
          ))}
          {Array.from({ length: 10 - (petsitters?.length || 0) }).map((_, index) => (
            <EmptyPetsitterSlot key={`empty-${index}`} />
          ))}
        </Box>
        <EmtSeparator />
        <EmtTypography variant="body1" sx={{ fontWeight: 700, lineHeight: '1.1' }}>
          Ajoutez des pet sitters à votre demande et contactez-les tous en une seule fois !
        </EmtTypography>
        <EmtTypography variant="body2" sx={{ lineHeight: '1.1' }}>
          En contactant jusqu’à 10 pet sitters, vous multipliez par 2 vos chances de trouver la bonne personne.
        </EmtTypography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <LinkButton color="purple" fullWidth href={Routes.PetSitter.Search}>
            Sélectionner plus de pet sitters
          </LinkButton>
          {petsitters.length > 0 && (
            <LinkButton color="purple" variant="text" fullWidth href={Routes.PetSitter.Reservations.NewRequest}>
              Contacter seulement ce pet-sitter
            </LinkButton>
          )}
        </Box>
      </Box>
    </EmtModal>
  )
}

export default SelectMoreModal
